module.exports = __webpack_public_path__ + "img/抽福袋.910879c1.jpg";